import './FaqResults.scss';

import React, { useEffect, useState } from 'react';

import FaqItem from './FaqItem';
import PropTypes from 'prop-types';

const FaqCategories = ({isSearch, defaultCategory = null, categoriesList, postsByTerm}) => {
    const [selectedCategory, setSelectedCategory] = useState(null);
    const baseUrl = new URL(window.location);

    useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      const categorySlug = params.get("category");

      if (categorySlug) {
        const matchingCategory = categoriesList.find((category) => category.slug === categorySlug);
        if (matchingCategory) {
          setSelectedCategory(matchingCategory);
        }
      } else {
        setSelectedCategory(defaultCategory);
      }

    }, [postsByTerm]);

    const handleFilter = (selectedCategory) => {
      setSelectedCategory(selectedCategory);
      updateUrl(baseUrl, selectedCategory.slug);
    };

    const updateUrl = (baseUrl, term) => {
      baseUrl.searchParams.set("category", term);
      window.history.pushState({}, "", baseUrl);
    }

    return (
      <>
        <section className="CategoryFilters">
          <h2 className="category-filters__title">Kategorier</h2>
          <ul className="CategoryFilters__List" role="radiogroup" aria-labelledby="category-filters-title">
            {categoriesList.map((option, index) =>
              <li className={`CategoryFilters__Item ${selectedCategory?.id === option.id ? "active" : ""}`} key={index}>
                <label className="CategoryFilters__Label">
                  <input
                    className="CategoryFilters__Input"
                    type="radio"
                    name="filter"
                    aria-label={`"Visa frågor och svar för "${option.title}`}
                    value={option.slug}
                    aria-checked={selectedCategory?.id === option.id}
                    onChange={(e) => handleFilter(option)} />
                  <span>{option.title}</span>
                </label>
            </li>
            )}
          </ul>
        </section>
        <div className="FaqResults" aria-live="polite" aria-atomic={true}>
          {(() => {
            if (!!selectedCategory?.id) {
              return <FaqResultsFilteredList postsByTerm={postsByTerm} selectedCategory={selectedCategory} />;
            }
              return <FaqResultsCategoryList postsByTerm={postsByTerm} />;
          })()}
        </div>
      </>
    );
}

FaqCategories.propTypes = {
  isSearch: PropTypes.bool,
  defaultCategory: PropTypes.object,
  postsByTerm: PropTypes.object,
  filter: PropTypes.string,
};

FaqCategories.defaultProps = {
  isSearch: false,
  defaultCategory: {},
  categoriesList: [],
  postsByTerm: {},
  filter: '',
};

export default FaqCategories;

const FaqResultsFilteredList = (postsByTerm) => {
  const cat = postsByTerm.selectedCategory;
  const list = postsByTerm.postsByTerm[cat.id];

  return (
    <>
      <h2 className="FaqResults__CategoryTitle">
        <img className="FaqResults__CategoryIcon" src={cat?.icon}  alt="" />
        <span>{cat.title}</span>
      </h2>
      <ul className="FaqResults__AccordionList">
        {list.posts.map((post, index) =>
          <FaqItem key={index} question={post.post_title} answer={post.answer} />
        )}
      </ul>
    </>
  )
}

const FaqResultsCategoryList = (postsByTerm) => {
  const list = postsByTerm.postsByTerm;

  return (
    <ul className="FaqResults__CategoryList">
      {Object.values(list).map(category => (
        <li className="FaqResults__CategoryItem" key={category?.term?.term_id || Math.random()}>
          <h2 className="FaqResults__CategoryTitle">
            {category?.iconPath && (
              <img
                className="FaqResults__CategoryIcon"
                src={category.iconPath}
                alt={`${category?.term?.name || 'Category'} icon`}
              />
            )}
            <span>{category?.term?.name || 'Unknown Category'}</span>
          </h2>

          <ul className="FaqResults__AccordionList">
              {category.posts.map(post => (
                <FaqItem question={post.post_title} answer={post.answer} key={post.post_title} />
              ))}
          </ul>
        </li>
      ))}
    </ul>
  )
}

